import Vue from "vue";

export const bankStatementUploadService = {
  uploadBankStatementXMLFile(file) {
    return Vue.http.post("api/uploadBankStatementXMLFile", file);
  },
};

export const paycheckUploadService = {
  uploadPaycheckXLSFile(file) {
    return Vue.http.post("api/uploadPaycheckXLSFile", file);
  },
};

export const contractorsFeesUploadService = {
  uploadContractorsFeesXLSFile(file) {
    return Vue.http.post("api/uploadContractorsFeesXLSFile", file);
  },
};

export const transactionService = {
  getAll(scope) {
    return Vue.http.get(`api/transactions${scope ? "/" + scope : ""}`);
  },
  getAllWithAccounts(scope) {
    return Promise.all([accountService.getAll(), this.getAll(scope)]).then(([acountsResponse, transactionsResponse]) => {
      return {
        transactions: transactionsResponse.body,
        accounts: acountsResponse.body,
      };
    });
  },
  get(id) {
    return Vue.http.get("api/transaction/" + id);
  },
  create(data) {
    return Vue.http.post("api/transaction", data);
  },
  bulkInsert(data) {
    return Vue.http.post("api/bulkInsertTransactions", data);
  },
  delete(data) {
    return Vue.http.post("api/deleteTransaction", data);
  },
  getUserTodosCount() {
    return Vue.http.get("api/getUserTodosCount");
  },
};

export const transactionHistoryService = {
  getAll() {
    return Vue.http.get("api/transactionHistory");
  },
};

export const accountService = {
  getAll() {
    return Vue.http.get("api/account");
  },
};

export const reportService = {
  getAll(selectedYear) {
    return Vue.http.get("api/report/" + selectedYear);
  },
};

export const saldoService = {
  getAll(selectedYear) {
    return Vue.http.get("api/saldo/" + selectedYear);
  },
};

export const userService = {
  updateSeenHistoryDate() {
    return Vue.http.post("api/user/updateSeenHistoryDate");
  },
};
